// Initialize when page loads
document.addEventListener('DOMContentLoaded', () => {
    initializeTimeline();
});

const callback = (entries, observer)=>{
  entries.forEach(entry => {
    if (entry.isIntersecting) {
        entry.target.classList.toggle("active", entry.isIntersecting);
    }
  });
}

const initializeTimeline = ()=>{

    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
    };

    const observer = new IntersectionObserver(callback, options);

    const target = document.querySelector(".wp-block-mlab-timeline");
    observer.observe(target);

}